export const DEFAULT_BORDER_WIDTH = 1
export const DEFAULT_BOX_SHADOW = 'md'
export const DEFAULT_DISABLED_OPACITY = 0.5

export const loadingIconProps = {
  animation: 'vui-spin 0.6s linear infinite',
  name: 'uiSpinnerThird',
  pathFill: ['currentColor', 'transparent'],
}

export const CSS_VAR_MAPPINGS = {
  base: {
    bg: '--vui-button-bg',
    borderColor: '--vui-button-border-color',
    color: '--vui-button-color',
    hoverBg: '--vui-button-hover-bg',
    hoverBorderColor: '--vui-button-hover-border-color',
    hoverColor: '--vui-button-hover-color',
    activeBg: '--vui-button-active-bg',
    activeBorderColor: '--vui-button-active-border-color',
    activeColor: '--vui-button-active-color',
  },
  active: {
    bg: '--vui-button-active-bg',
    borderColor: '--vui-button-active-border-color',
    color: '--vui-button-active-color',
    hoverBg: '--vui-button-active-hover-bg',
    hoverBorderColor: '--vui-button-active-hover-border-color',
    hoverColor: '--vui-button-active-hover-color',
  },
  disabled: {
    bg: '--vui-button-disabled-bg',
    borderColor: '--vui-button-disabled-border-color',
    color: '--vui-button-disabled-color',
    opacity: '--vui-button-disabled-opacity',
  },
} as const
